module.exports = __webpack_public_path__ + "style/img/Group 1929.098f02af.png";